export default __webpack_public_path__ + "static/media/free-trial-man.2bfbf428.png";